import React, {useCallback, useMemo, useState, useEffect, useRef} from "react";
import TextInput from "../component/TextInput";
import LargeCardVertical from "../set/LargeCardVertical";
import SearchCardVertical from "../set/SearchCardVertical";
import useFetch from "@common/hooks/fetch/useFetch";
import {getSearchDetailInfo, getSearchInfo} from "@common/services/restapi/search";
import Page from '../../../common/enums/Page.enums'
import {useAsyncFn} from "react-use";
import {getAdCategoryList} from "@common/services/restapi/ad";
import {convertPath} from "@common/utils/path/linkPath";

function Search() {
  let urlSearchParams = new URLSearchParams(location.search);
  const keyword = urlSearchParams.get("keyword");
  const [search, setSearch] = useState(keyword);
  const [data, setData] = useState({});

  const [searchState, handleSearchState] = useAsyncFn(async(keyword) => {
    if (!searchState.loading) {
      const searchResult = await getSearchInfo(keyword);
      setData(searchResult);
    }
  }, []);

  const handleUserInput = (e) => {
    setSearch(e.target.value);
  }

  const onSubmitSearch = (e) => {
    if (e.key === "Enter" && e.target.value) {
      setSearch(e.target.value);
      window.location.replace(convertPath("/search?keyword=" + e.target.value));
      // handleSearchState(e.target.value);
    }
  };

  const clearUserInput = () => {
    setSearch("");
  }

  useEffect(() => {
    if (keyword) {
      handleSearchState(keyword);
    }
  },[keyword]);

  return (
    <div className="search-wrap">
      <div className="common-header--top">
        <h3 className="header-title">통합검색</h3>
      </div>
      <section className="search">
        <TextInput
          hasLabel={false}
          labelText=""
          placeHolderText="검색어를 입력하세요"
          hasLeftIcon={true}
          leftIconName="magnify"
          hasErrorText={false}
          errorText="형식이 맞지 않습니다"
          value={search}
          onChange={handleUserInput}
          onClick={clearUserInput}
          onKeyPress={onSubmitSearch}
        />
        {/*<div className="best-search-text">
          <div className="title">인기검색어</div>
          <ul className="best-search-text-list">
            <li>이승기</li>
            <li>러블리즈</li>
            <li>쇼미더머니</li>
            <li>BTS</li>
            <li>유재석</li>
          </ul>
        </div>*/}
        {
          !searchState.loading && data && data.adList &&
          <AdSearchResult category={'ad'} adResultData={data.adList} keyword={search} pageNumber={data.adPageInfo.pageNumber} pageSize={data.adPageInfo.pageSize}/>
        }

        {
          !searchState.loading && data && data.articleList &&
          <MagazineSearchResult category={'journal'} magazineResultData={data.articleList} keyword={search} pageNumber={data.articlePageInfo.pageNumber} pageSize={data.articlePageInfo.pageSize}/>
        }

      </section>
    </div>
  )
}

function AdSearchResult ({category, adResultData, pageNumber, pageSize, keyword}) {
  const [adData, setAdData] = useState(adResultData);
  const [adPageNumber, setAdPageNumber] = useState(pageNumber)
  const [adPageSize, setAdPageSize] = useState(pageSize)

  const [searchDetail, handleSearchDetail] = useAsyncFn(async(category, keyword, pageNumber, pageSize, nowAdData) => {
    if (!searchDetail.loading) {
      let adResultList = await getSearchDetailInfo(category, keyword, pageNumber, pageSize);
      if (adData) {
        setAdData(nowAdData.concat(adResultList.adList));
        setAdPageNumber(pageNumber);
      }
    }
  }, []);

  const handleViewMore = () => {
    handleSearchDetail(category, keyword, adPageNumber + 1, adPageSize, adData)
  }

  console.log(adData)

  return (
    <>
      {
        adData && adData.length > 0 &&
        <>
          <div className="section-header">
            <h5 className="title">크리에이티브</h5>
          </div>
          <div className="section-body">
            <div className="thumbnail-wrap">
              <SearchCardVertical
                source={adData}
                isFullThumbnail={true}
                link={`/ad/`}
                additionalInfo={false}
                additionalClass="main-list"
              />
              <div className="view-more" onClick={handleViewMore}>
                <button>
                  <div>
                    더보기
                  </div>
                  <i className="mdi mdi-chevron-right"/>
                </button>
              </div>
            </div>
          </div>
        </>
      }
    </>
  )
}

function MagazineSearchResult ({category, magazineResultData, pageNumber, pageSize, keyword}) {
  const [magazineData, setMagazineData] = useState(magazineResultData);
  const [magazinePageNumber, setMagazinePageNumber] = useState(pageNumber)
  const [magazinePageSize, setMagazinePageSize] = useState(pageSize)

  const [searchDetail, handleSearchDetail] = useAsyncFn(async(category, keyword, pageNumber, pageSize, nowMagazineData) => {
    if (!searchDetail.loading) {
      const magazineResultList = await getSearchDetailInfo(category, keyword, pageNumber, pageSize);
      if (magazineData) {
        setMagazineData(nowMagazineData.concat(magazineResultList.articleList));
        setMagazinePageNumber(pageNumber);
      }
    }
  }, []);

  const handleViewMore = () => {
    handleSearchDetail(category, keyword, magazinePageNumber + 1, magazinePageSize, magazineData)
  }

  console.log(magazineData)
  return (
    <>
      {
        magazineData && magazineData.length > 0 &&
        <>
          <div className="section-header">
            <h5 className="title">매거진</h5>
          </div>
          <div className="section-body">
            <div className="thumbnail-wrap">
              <LargeCardVertical
                source={magazineData}
                isFullThumbnail={true}
                link={`/magazine/`}
                additionalInfo={false}
                additionalClass="main-list"
              />
              <div className="view-more" onClick={handleViewMore}>
                <button>
                  <div>
                    더보기
                  </div>
                  <i className="mdi mdi-chevron-right"/>
                </button>
              </div>
            </div>
          </div>
        </>
      }
    </>
  )
}
export default Search;
